import { QualityCheck, QualityCheckProps } from "../quality-check";

type Props = QualityCheckProps;

export function NationalProcurementReferenceQualityCheck(props: Props) {
  if (props.data.Name !== "Referenser Nationella") {
    throw new Error("ReferenceQualityCheck can only be used for Referenser Nationella");
  }

  return (
    <QualityCheck
      {...props}
      disabled={false}
      withDefaultStatuses={false}
    />
  );
}
